import { useIntl } from 'react-intl';
import {
  BreadcrumbItem,
  Breadcrumbs,
} from '@rossum/components/breadcrumbs/Breadcrumbs';
import { settingsPath } from './helpers';

type SettingsBreadcrumbsProps = {
  breadcrumbs: BreadcrumbItem[];
};

export const SettingsBreadcrumbs = ({
  breadcrumbs,
}: SettingsBreadcrumbsProps) => {
  const intl = useIntl();

  const settingsBreadcrumbs = [
    {
      to: settingsPath(),
      label: intl.formatMessage({ id: 'components.appBar.settings' }),
    },
    ...breadcrumbs,
  ] as const;

  return <Breadcrumbs breadcrumbs={settingsBreadcrumbs} />;
};
